


















import Element from '../../../mixins/element';
import { Component, Watch } from 'vue-property-decorator';

@Component
export default class Cvc extends Element {
    get id() {
        return this.integrationData.setup.fields
            ? this.integrationData.setup.fields.cvv.selector.replace('#', '')
            : 'cvvPS';
    }

    public toMount() {
        this.loading = true;
        this.$nextTick(() => {
            this.loading = false;
        });
    }

    public performInput(event) {
        this.input = {
            isEmpty: event.data.isEmpty,
        };
    }

    public onIntegrationData(val) {
        if (!Object.keys(val).length) {
            return;
        }

        this.loading = false;
        val.fields.cvv.on('FieldValueChange', (data, event) => {
            this.performInput(event);
        });

        val.fields.cvv.on('Focus', (data, event) => {
            this.onFocus();
        });

        val.fields.cvv.on('Blur', (data, event) => {
            this.onBlur();
        });

        val.fields.cvv.on('Valid', (data, event) => {
            this.performInput(event);
        });

        val.fields.cvv.on('Invalid', (data, event) => {
            this.performInput(event);
        });
    }

    public toValidate(): boolean {
        return this.integrationData.paysafe.fields.cvv.isValid();
    }

    public toClear() {}

    public toDestroy() {}

    public toFocus(): void {}

    public toBlur(): void {}
}
